import { render, staticRenderFns } from "./SourceIdentifySetupView.vue?vue&type=template&id=3716533c&scoped=true&"
import script from "./SourceIdentifySetupView.vue?vue&type=script&lang=ts&"
export * from "./SourceIdentifySetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3716533c",
  null
  
)

export default component.exports